function generateStars(score) {
  const full = Math.floor(score);
  const half = score % 1 >= 0.5;
  let html = '';

  for (let i = 0; i < full; i++) {
    html += '<span class="star star-on"></span>';
  }

  if (half && full < 5) {
    html += '<span class="star star-half"></span>';
  }

  return html;
}

function renderRating(data) {
  // Ochrana proti neparsovanému JSON
  const d = typeof data === 'string' ? JSON.parse(data) : data;

  const ratings = d.ratings?.slice(0, 4) || [];

  const reviewHtml = ratings.map(r => {
    const date = formatAddedDate(r.created.date);

    return `
      <div class="review-item">
        <div class="review-name">Ověřený zákazník${r.fullName ? ` ${r.fullName}` : ''}</div>
        <div class="review-date">${date}</div>
        <div class="review-stars">
          <span class="h5">${parseInt(r.score) || 5}</span>
          <span class="stars">${generateStars(parseFloat(r.score) || 0)}</span>
        </div>
        ${r.description ? `<div class="review-description">${r.description}</div>` : ''}
      </div>
    `;
  }).join('');

  $('.reviews').html(reviewHtml);
}

$.ajax({
  url: '/hodnoceni-obchodu/?jsonFormat',
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'X-Store-Rating-Details': 'true'
  },
  success: function (response) {
    renderRating(response);
  },
  error: function (xhr, status, error) {
    console.error('Chyba při načítání hodnocení:', error);
  }
});

function formatAddedDate(dateString) {
  const inputDate = new Date(dateString.replace(" ", "T"));
  const now = new Date();

  const diffMs = now - inputDate;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
/*
  // méně než týden
  if (diffDays < 7) {
    if (diffDays <= 1) return "Přidáno dnes";
    return `Přidáno před ${diffDays} dny`;
  }

  // méně než měsíc (~30 dní)
  if (diffDays < 30) {
    if (diffWeeks === 1) return "Přidáno před týdnem";
    if (diffWeeks >= 2 && diffWeeks <= 4) {
      return `Přidáno před ${diffWeeks} týdny`;
    }
  }*/

  // starší než měsíc → konkrétní datum
  return "Přidáno " + inputDate.toLocaleDateString("cs-CZ", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });
}